import dimensionProps from "./dimension-props";

const widthProps = dimensionProps("height");

export default widthProps;
